// Specific error codes that the backend returns
export const MFA_REQUIRED_ERROR_CODE = 'MFA_MISSING_TOKEN'
export const MFA_SESSION_NOT_VERIFIED_ERROR_CODE = 'MFA_SESSION_NOT_VERIFIED'
export const MFA_SESSION_NOT_FOUND_ERROR_CODE = 'MFA_SESSION_NOT_FOUND'
export const MFA_TOKEN_EXPIRED_ERROR_CODE = 'MFA_EXPIRED_TOKEN'
export const MFA_SKIPPED_SESSION_EXPIRED_ERROR_CODE =
  'MFA_SKIPPED_SESSION_EXPIRED'
export const MFA_INVALID_TOKEN_ERROR_CODE = 'MFA_INVALID_TOKEN'
export const MFA_WRONG_CODE_ERROR_CODE = 'MFA_WRONG_CODE'

export const isMFAError = (error: string) => {
  return (
    error === MFA_REQUIRED_ERROR_CODE ||
    error === MFA_SESSION_NOT_VERIFIED_ERROR_CODE ||
    error === MFA_SESSION_NOT_FOUND_ERROR_CODE ||
    error === MFA_TOKEN_EXPIRED_ERROR_CODE ||
    error === MFA_SKIPPED_SESSION_EXPIRED_ERROR_CODE ||
    error === MFA_INVALID_TOKEN_ERROR_CODE ||
    error.includes(MFA_REQUIRED_ERROR_CODE) ||
    error.includes(MFA_SESSION_NOT_VERIFIED_ERROR_CODE) ||
    error.includes(MFA_SESSION_NOT_FOUND_ERROR_CODE) ||
    error.includes(MFA_TOKEN_EXPIRED_ERROR_CODE) ||
    error.includes(MFA_SKIPPED_SESSION_EXPIRED_ERROR_CODE) ||
    error.includes(MFA_INVALID_TOKEN_ERROR_CODE)
  )
}

export const isMFARequiredError = (error: string) => {
  return (
    error === MFA_REQUIRED_ERROR_CODE ||
    String(error).includes(MFA_REQUIRED_ERROR_CODE)
  )
}

export const isMFAExpiredTokenError = (error: string) => {
  return (
    error === MFA_TOKEN_EXPIRED_ERROR_CODE ||
    String(error).includes(MFA_TOKEN_EXPIRED_ERROR_CODE)
  )
}

export const isMFASkippedSessionExpiredError = (error: string) => {
  return (
    error === MFA_SKIPPED_SESSION_EXPIRED_ERROR_CODE ||
    String(error).includes(MFA_SKIPPED_SESSION_EXPIRED_ERROR_CODE)
  )
}

export const isMFASessionNotFoundError = (error: string) => {
  return (
    error === MFA_SESSION_NOT_FOUND_ERROR_CODE ||
    String(error).includes(MFA_SESSION_NOT_FOUND_ERROR_CODE)
  )
}

export const isMFASessionNotVerifiedError = (error: string) => {
  return (
    error === MFA_SESSION_NOT_VERIFIED_ERROR_CODE ||
    String(error).includes(MFA_SESSION_NOT_VERIFIED_ERROR_CODE)
  )
}

export const isMFAInvalidTokenError = (error: string) => {
  return (
    error === MFA_INVALID_TOKEN_ERROR_CODE ||
    String(error).includes(MFA_INVALID_TOKEN_ERROR_CODE)
  )
}

export const isMFAWrongCodeError = (error: string) => {
  return (
    error === MFA_WRONG_CODE_ERROR_CODE ||
    String(error).includes(MFA_WRONG_CODE_ERROR_CODE)
  )
}
